module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg1-8adc7ef76399672c83e75fe88614fc95.jpg";